import { render, staticRenderFns } from "./UserCostManager2.vue?vue&type=template&id=6716144c&scoped=true&"
import script from "./UserCostManager2.vue?vue&type=script&lang=js&"
export * from "./UserCostManager2.vue?vue&type=script&lang=js&"
import style0 from "./UserCostManager2.vue?vue&type=style&index=0&id=6716144c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716144c",
  null
  
)

export default component.exports